import { PageId } from 'constants/pages'

export const enum PageIdWoofzNrday75 {
  SUBSCRIPTIONS_NRDAY_75_N = PageId.SUBSCRIPTIONS_NRDAY_75_N,
  CHAT_UPSELL_NRDAY_75 = PageId.CHAT_UPSELL_NRDAY_75,
  UPSELL_NRDAY_75 = PageId.UPSELL_NRDAY_75,
  DOWNLOAD_NRDAY_75 = PageId.DOWNLOAD_NRDAY_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
